import { render, staticRenderFns } from "./WorkerCostShift.vue?vue&type=template&id=48ffbfac&scoped=true"
import script from "./WorkerCostShift.vue?vue&type=script&lang=js"
export * from "./WorkerCostShift.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48ffbfac",
  null
  
)

export default component.exports